import {DateTime, Duration} from "luxon";
import AUTHDISTRIBUTORMEMBERSHIP from "../auth/AuthDistributorMembership";

/**
 * @param {Array<Event>} events
 * @return Array<Event>
 */
export function filterUpcomingEvents(events) {
    let yesterday = DateTime.local().minus(Duration.fromObject({days: 1})).endOf('day').toMillis();
    let now = DateTime.local().toMillis();

    return events.filter(event =>
        AUTHDISTRIBUTORMEMBERSHIP.isMemberOfDistributor(event.distributor)
        && !event.deleted
        && event.start
        && (
            ( !event.end && event.start.getTime() > yesterday)
            ||
            ( !!event.end && event.end.getTime() > now)
        ));
}

export function filterPastEvents(events) {
    let yesterday = DateTime.local().minus(Duration.fromObject({days: 1})).endOf('day').toMillis();
    let now = DateTime.local().toMillis();

    return events.filter(event =>
        AUTHDISTRIBUTORMEMBERSHIP.isMemberOfDistributor(event.distributor)
        && !event.deleted
        && event.start
        && (
            ( !event.end && event.start.getTime() < yesterday)
            ||
            ( !!event.end && event.end.getTime() < now)
        ));
}
